import DiamondReportsClarityComp from "../DiamondReportsClarityComp";
import DiamondReportsColorComp from "../DiamondReportsColorComp";
import DiamondReportsCutGradeComp from "../DiamondReportsCutGradeComp";
import DiamondReportsShapeComp from "../DiamondReportsShapeComp";
import DiamondReportsCertificateComp from "../DiamondReportsCertificateComp";
import DiamondReportsSizeComp from "../DiamondReportsSizeComp";
import DiamondReportsClicksComp from "../DiamondReportsClicksComp";
import { isValidShape } from "./isValidShape";
import { isValidCutGrade } from "./isValidCutGrade";

// One config per report, consumed by ReportScaffold. dataKey/labelField/valueField
// describe where to read the attribute's slice out of the shared
// LoadExtendedDiamondChartReports("ExtDiamondChrt") payload; ChartCard is the
// existing, already-Chart.js-based presentational component (built for the
// Extended report's tabs) reused as-is.

export const CLARITY_CONFIG = {
  key: "clarity",
  dataKey: "DiamondClaritySearches",
  labelField: "Clarity",
  valueField: "CNT",
  dimensionLabel: "Clarity",
  pageTitle: "Diamond Clarity Report",
  ChartCard: DiamondReportsClarityComp,
  noiseFilter: null,
  detail: { reportName: "Clarity", filterParamName: "clarity", fileNamePart: "DiamondClarityReports" },
};

export const COLOR_CONFIG = {
  key: "color",
  dataKey: "DiamondColorSearches",
  labelField: "Color",
  valueField: "CNT",
  dimensionLabel: "Color",
  pageTitle: "Diamond Color Report",
  ChartCard: DiamondReportsColorComp,
  noiseFilter: null,
  detail: { reportName: "Color", filterParamName: "color", fileNamePart: "DiamondColorReports" },
};

export const CUTGRADE_CONFIG = {
  key: "cutGrade",
  dataKey: "DiamondCutGradeSearches",
  labelField: "CutGrade",
  valueField: "CNT",
  dimensionLabel: "Cut Grade",
  pageTitle: "Diamond Cut Report",
  ChartCard: DiamondReportsCutGradeComp,
  noiseFilter: { isValid: isValidCutGrade, toggleLabel: "Hide noise / invalid terms" },
  detail: { reportName: "CutGrade", filterParamName: "cutGrade", fileNamePart: "DiamondCutReports" },
};

export const SHAPE_CONFIG = {
  key: "shape",
  dataKey: "DiamondShapeSearches",
  labelField: "Cut", // shape label is stored under the "Cut" column in this table
  valueField: "CNT",
  dimensionLabel: "Shape",
  pageTitle: "Diamond Shape Report",
  ChartCard: DiamondReportsShapeComp,
  noiseFilter: { isValid: isValidShape, toggleLabel: "Hide noise / invalid terms" },
  detail: { reportName: "Shape", filterParamName: "shape", fileNamePart: "DiamondShapeReports" },
};

export const CERTIFICATE_CONFIG = {
  key: "certificate",
  dataKey: "DiamondCertificateSearches",
  labelField: "Certificate",
  valueField: "CNT",
  dimensionLabel: "Certificate",
  pageTitle: "Diamond Certificate Report",
  ChartCard: DiamondReportsCertificateComp,
  noiseFilter: null,
  detail: { reportName: "Certificate", filterParamName: "certificate", fileNamePart: "DiamondCertificateReports" },
};

export const SIZE_CONFIG = {
  key: "size",
  dataKey: "DiamondSizeSearches",
  labelField: "Size",
  valueField: "CNT",
  dimensionLabel: "Size",
  pageTitle: "Diamond Size Report",
  ChartCard: DiamondReportsSizeComp,
  noiseFilter: null,
  detail: { reportName: "Size", filterParamName: "size", fileNamePart: "DiamondSizeReports" },
};

export const CLICKS_CONFIG = {
  key: "clicks",
  dataKey: "DiamondClicks",
  labelField: "Date",
  valueField: "CNT",
  dimensionLabel: "Day",
  pageTitle: "Diamond Clicks Report",
  ChartCard: DiamondReportsClicksComp,
  noiseFilter: null,
  // "Total Day Searches" would just re-sum the same CNT column as Total
  // Clicks (redundant) — hide it in ReportKpiStrip for this report.
  hideTotalDimensionSum: true,
  // No detail table here — the DiamondVendorTableChartAll SP has no verified
  // "Clicks" reportName branch, so ClicksIndComp wires ClickEventsTable
  // (DimondChart_SortingBindData) directly instead of DetailSearchTable.
};
